import React from 'react'

function SettingsIcon({ color = '#141414' }: { color?: string }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.5 9C10.0523 9 10.5 8.55228 10.5 8C10.5 7.44772 10.0523 7 9.5 7C8.94772 7 8.5 7.44772 8.5 8C8.5 8.55228 8.94772 9 9.5 9ZM9.5 11C11.1569 11 12.5 9.65685 12.5 8C12.5 6.34315 11.1569 5 9.5 5C8.18867 5 7.07385 5.84136 6.6659 7.0137C6.61194 7.00469 6.55652 7 6.5 7L4.5 7C3.94772 7 3.5 7.44772 3.5 8C3.5 8.55228 3.94772 9 4.5 9L6.5 9C6.55652 9 6.61194 8.99531 6.6659 8.9863C7.07385 10.1586 8.18867 11 9.5 11ZM4.5 15C3.94772 15 3.5 15.4477 3.5 16C3.5 16.5523 3.94772 17 4.5 17H10.5C11.0523 17 11.5 16.5523 11.5 16C11.5 15.4477 11.0523 15 10.5 15H4.5ZM13.5 8C13.5 7.44772 13.9477 7 14.5 7H20.5C21.0523 7 21.5 7.44772 21.5 8C21.5 8.55228 21.0523 9 20.5 9H14.5C13.9477 9 13.5 8.55228 13.5 8ZM16.5 16C16.5 15.4477 16.0523 15 15.5 15C14.9477 15 14.5 15.4477 14.5 16C14.5 16.5523 14.9477 17 15.5 17C16.0523 17 16.5 16.5523 16.5 16ZM20.5 15H18.3293C17.9175 13.8348 16.8062 13 15.5 13C13.8431 13 12.5 14.3431 12.5 16C12.5 17.6569 13.8431 19 15.5 19C16.8062 19 17.9175 18.1652 18.3293 17H20.5C21.0523 17 21.5 16.5523 21.5 16C21.5 15.4477 21.0523 15 20.5 15Z'
        fill={color}
      />
    </svg>
  )
}

export default SettingsIcon
